import { React } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd-mobile';
import { Space } from 'antd';

const PreferenceQuestionnaireSuccess = () => {
  const navigate = useNavigate();

  const selectTypeClick = () => {
    navigate('/m/Bind/SelectType');
  };

  return (
    <div className="main-container">
      <div className="form-container">
        <div className="text-align-center">
          <img
            className="pd-6"
            src="/images/illustration/survey-done.svg"
            alt="Description"
          />
          <div className="pd-6">
            <div className="heading font-bold mb-2">您已完成問卷</div>
            <div className="text-body font-normal">
              您的填寫，祝您有個美好的一天～
            </div>
          </div>
          <div>
            <Button
              block
              onClick={selectTypeClick}
              className="primary-button"
              style={{ marginBottom: '8px' }}>
              前往會員綁定
            </Button>
            <Button block className="light-button">
              返回LINE官方帳號
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreferenceQuestionnaireSuccess;
